import axios from 'axios';

export const CDN_ASSETS_BASE = 'https://assets-cdn.assessfirst.info';

const CDN_BASE = `${CDN_ASSETS_BASE}/static-data`;

// Isolated instance — no auth headers, no X-AF-Client, no cookies.
// CDN is public S3/CloudFront and rejects custom headers in CORS preflight.
const cdnAxios = axios.create({ withCredentials: false });

export type CdnPersonality = Record<string, { gradients: [string, string] }>;
// Shape stored as-is in the `locale` cookie shared with the other apps —
// ne pas réduire les champs, assessments et personal-account lisent l'objet brut.
export type CdnLocale = {
  id: number;
  flag: string;
  iso_code: string;
  iso_code_639: string;
  label: string;
  google_id: string;
  language_key: string;
  localized_language_key: string;
};

// Cached: le mapping id <-> iso sert au boot, au switcher et à la synchro /me.
let localesPromise: Promise<CdnLocale[]> | null = null;

export function fetchLocales(): Promise<CdnLocale[]> {
  localesPromise ??= cdnAxios
    .get(`${CDN_BASE}/locales.json`)
    .then(({ data }) => data ?? [])
    .catch(error => {
      localesPromise = null;
      throw error;
    });

  return localesPromise;
}

// Cached across callers: every avatar on screen needs the same mapping.
let personalityPromise: Promise<CdnPersonality> | null = null;

export function fetchPersonality(): Promise<CdnPersonality> {
  personalityPromise ??= cdnAxios
    .get(`${CDN_BASE}/personality.json`)
    .then(({ data }) => data ?? {})
    .catch(error => {
      personalityPromise = null;
      throw error;
    });

  return personalityPromise;
}
